/* ============================================================
   SWORDSLIFE-OZEL (yeni dosya, 2026-10-09). Defter: snippets/swordslife-changelog.liquid
   SWORDSLIFE FAVORILER (Wishlist by Square yerine kendi sistemimiz)
   - Kalp: urun kartlari (.product-card), urun sayfasi (.product-form__buttons), ust menu ovali.
   - Sagdan acilan favori cekmecesi: urunler, sepete ekle, kaldir, paylas (WhatsApp/Telegram/kopyala), "Tumu" sayfasi.
   - Kayit: misafir -> tarayici (localStorage sl_wl_v1); giris yapmis -> Shopify musteri kaydi
     (Cloudflare Worker /apps/sl-account/wishlist). Giris yapinca misafir listesi hesaba aktarilir.
   - Eski uygulamanin listesi (localStorage __v__wl__l__) ilk calismada otomatik aktarilir.
   - Urun bilgisi: sections/sl-wl-data.liquid (arama sonucu, JSON).
   - TEST ANAHTARI: ?slwl=1 bu tarayicida acar, ?slwl=0 kapatir. Herkese acmak icin: window.SL_WL_FORCE = true
     (layout/theme.liquid'de, script'ten once).
   ============================================================ */
(function () {
  'use strict';
  var KEY = 'sl_wl_v1', FLAG = 'sl_wl_on', API = '/apps/sl-account/';
  try {
    var q = new URLSearchParams(location.search).get('slwl');
    if (q === '1') localStorage.setItem(FLAG, '1');
    if (q === '0') localStorage.removeItem(FLAG);
  } catch (e) {}
  var ON = window.SL_WL_FORCE === true;
  try { ON = ON || localStorage.getItem(FLAG) === '1'; } catch (e) {}
  if (!ON || window.slWishlist) return;

  var html = document.documentElement;
  html.classList.add('sl-wl-on');
  /* Stil dosyasi sadece sistem aciksa yuklenir */
  (function () {
    var me = document.currentScript && document.currentScript.src;
    if (!me && !window.SL_WL_CSS) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    /* SWORDSLIFE-OZEL (2026-10-09): CSS'in kendi surum adresi (theme.liquid verir); yoksa JS adresinden tahmin */
    l.href = window.SL_WL_CSS || me.replace('sl-wishlist.js', 'sl-wishlist.css');
    document.head.appendChild(l);
  })();

  /* ---------------- Durum ---------------- */
  var listeners = [];
  var S = read();
  function read() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (d && Array.isArray(d.items)) { d.lists = Array.isArray(d.lists) ? d.lists : []; return d; }
    } catch (e) {}
    return null;
  }
  function write() { try { localStorage.setItem(KEY, JSON.stringify(S)); } catch (e) {} }
  function emit() { listeners.forEach(function (f) { try { f(S); } catch (e) {} }); }
  function cid() {
    var el = document.querySelector('[data-sl-cid]');
    return el ? (el.getAttribute('data-sl-cid') || '') : '';
  }
  function idx(p) { p = String(p); for (var i = 0; i < S.items.length; i++) if (String(S.items[i].p) === p) return i; return -1; }
  function has(p) { return idx(p) > -1; }

  /* ---------------- Sunucu ---------------- */
  var pushT;
  function push() {
    if (!cid()) return;
    clearTimeout(pushT);
    pushT = setTimeout(function () {
      fetch(API + 'wishlist', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: S.items, lists: S.lists })
      }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
        if (j && j.ok && j.wishlist) { S.items = j.wishlist.items; S.lists = j.wishlist.lists; S.sync = cid(); write(); emit(); }
      }).catch(function () {});
    }, 350);
  }
  function guestCount(add, remove) {
    if (cid()) return;
    fetch(API + 'wl-count', {
      method: 'POST', credentials: 'same-origin', keepalive: true,
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ add: add || [], remove: remove || [] })
    }).catch(function () {});
  }
  function syncFromServer() {
    var c = cid();
    if (!c) {
      /* Cikis yapilmis: onceki hesabin listesi bu cihazda kalmasin */
      if (S.sync) { S = { items: [], lists: [] }; write(); emit(); }
      return;
    }
    fetch(API + 'wishlist', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.ok) return;
        var srv = j.wishlist || { items: [], lists: [] };
        if (S.sync !== c) {
          /* Ilk giris bu cihazda: misafir listesini hesaba ekle */
          var map = {};
          srv.items.concat(S.items).forEach(function (i) { if (i.p && !map[i.p]) map[i.p] = i; });
          S.items = Object.keys(map).map(function (k) { return map[k]; }).sort(function (a, b) { return (b.t || 0) - (a.t || 0); });
          S.lists = srv.lists.length ? srv.lists : S.lists;
          S.sync = c; write(); emit(); push();
        } else {
          S.items = srv.items; S.lists = srv.lists; write(); emit();
        }
      }).catch(function () {});
  }

  /* ---------------- Ilk kurulum / eski uygulamadan aktarim ---------------- */
  function resolveVariant(v) {
    return fetch('/variants/' + encodeURIComponent(v), { method: 'HEAD', credentials: 'same-origin' }).then(function (r) {
      var m = r.url && r.url.match(/\/products\/([^/?#]+)/);
      if (!m) return null;
      return fetch('/products/' + m[1] + '.js').then(function (x) { return x.ok ? x.json() : null; });
    }).then(function (pj) { return pj ? String(pj.id) : null; }).catch(function () { return null; });
  }
  function boot() {
    if (S) return Promise.resolve();
    S = { items: [], lists: [] };
    var old = [];
    try {
      var d = JSON.parse(localStorage.getItem('__v__wl__l__') || '{}');
      var it = d.items || {};
      old = (Array.isArray(d.list) ? d.list : []).filter(function (id) { return !(it[id] && it[id].deleted); }).map(String);
    } catch (e) {}
    if (!old.length) { write(); return Promise.resolve(); }
    return Promise.all(old.slice(0, 100).map(function (v) {
      return resolveVariant(v).then(function (p) { return p ? { p: p, v: v, t: Date.now() } : null; });
    })).then(function (arr) {
      var seen = {};
      S.items = arr.filter(function (x) { if (!x || seen[x.p]) return false; seen[x.p] = 1; return true; });
      write();
    });
  }

  /* ---------------- Islemler ---------------- */
  function add(p, v, silent) {
    p = String(p || '').replace(/\D/g, ''); v = String(v || '').replace(/\D/g, '');
    if (!p || has(p)) return;
    S.items.unshift({ p: p, v: v, t: Date.now() });
    write(); emit(); push(); guestCount([p], []);
    if (!silent) toast('Saved to favorites', true);
  }
  function remove(p, silent) {
    p = String(p); var i = idx(p);
    if (i < 0) return;
    S.items.splice(i, 1);
    S.lists.forEach(function (l) { l.items = (l.items || []).filter(function (x) { return String(x) !== p; }); });
    write(); emit(); push(); guestCount([], [p]);
    if (!silent) toast('Removed from favorites');
  }
  function toggle(p, v) { if (has(p)) remove(p); else add(p, v); }

  /* ---------------- Urun bilgisi ---------------- */
  var cache = {};
  function loadProducts(pids) {
    var need = pids.filter(function (p) { return !cache[p]; });
    var chunks = [];
    for (var k = 0; k < need.length; k += 25) chunks.push(need.slice(k, k + 25));
    return Promise.all(chunks.map(function (ch) {
      var url = '/search?type=product&section_id=sl-wl-data&q=' + encodeURIComponent(ch.map(function (p) { return 'id:' + p; }).join(' OR '));
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var s = doc.querySelector('[data-slwl-json]');
        var arr = [];
        try { arr = JSON.parse(s ? s.textContent : '[]'); } catch (e) {}
        arr.forEach(function (pr) { cache[String(pr.id)] = pr; });
        ch.forEach(function (p) { if (!cache[p]) cache[p] = { id: p, gone: true }; });
      }).catch(function () {});
    })).then(function () { return pids.map(function (p) { return cache[p]; }).filter(Boolean); });
  }
  function pickVariant(pr, v) {
    var vs = pr.v || [];
    var hit = null;
    if (v) vs.forEach(function (x) { if (String(x.id) === String(v)) hit = x; });
    if (!hit) vs.forEach(function (x) { if (!hit && x.a) hit = x; });
    return hit || vs[0] || null;
  }

  /* ---------------- Sepet ---------------- */
  function cartSections() {
    var s = [];
    try { document.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: s } })); } catch (e) {}
    return s.filter(function (v, i, a) { return v && a.indexOf(v) === i; });
  }
  function addToCart(items) {
    var body = { items: items };
    var secs = cartSections();
    if (secs.length) { body.sections = secs.join(','); body.sections_url = location.pathname; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return r.ok ? j : null; }); }).then(function (state) {
      if (!state) return false;
      return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        if (state.sections) cart.sections = state.sections;
        try { if (window.FoxTheme && FoxTheme.pubsub) FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart }); } catch (e) {}
        document.querySelectorAll('cart-count').forEach(function (el) { el.textContent = cart.item_count > 99 ? '99+' : cart.item_count; el.hidden = cart.item_count < 1; });
        return true;
      });
    }).catch(function () { return false; });
  }
  function openCartDrawer() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.show === 'function') { try { d.show(); return true; } catch (e) {} }
    return false;
  }

  /* ---------------- Yardimci gorunum ---------------- */
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 7.7 3.6 4.5 7 4.5c2.1 0 3.7 1.1 5 2.8 1.3-1.7 2.9-2.8 5-2.8 3.4 0 5.6 3.2 4.3 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var toastEl, toastT;
  function toast(msg, withLink) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'slwl-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = '<span class="slwl-toast__ico">' + HEART + '</span><span>' + esc(msg) + '</span>' + (withLink ? '<button type="button" data-slwl-open>View</button>' : '');
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ---------------- Kalpler: urun kartlari ---------------- */
  function cardInfo(card) {
    var p = '', v = '';
    var pe = card.querySelector('[data-product-id]');
    if (pe) p = pe.getAttribute('data-product-id') || pe.value || '';
    if (!p) {
      var ev = card.querySelector('storefront-view-event');
      try { p = String(JSON.parse(ev.getAttribute('view-event-payload')).product.id); } catch (e) {}
    }
    var vi = card.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (vi) v = vi.value;
    return { p: String(p || '').replace(/\D/g, ''), v: v };
  }
  function mountCards(root) {
    (root || document).querySelectorAll('.product-card').forEach(function (card) {
      if (card.querySelector(':scope .slwl-heart')) return;
      var info = cardInfo(card);
      if (!info.p) return;
      var host = card.querySelector('.product-card__wrapper') || card;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'slwl-heart slwl-heart--card';
      b.setAttribute('data-slwl-p', info.p);
      if (info.v) b.setAttribute('data-slwl-v', info.v);
      b.setAttribute('aria-label', 'Save to favorites');
      b.innerHTML = HEART;
      host.appendChild(b);
    });
    paintHearts();
  }
  /* ---------------- Kalp: urun sayfasi ---------------- */
  function mountProduct() {
    document.querySelectorAll('product-info[data-product-id]').forEach(function (pi) {
      var box = pi.querySelector('.product-form__buttons');
      if (!box || box.querySelector('.slwl-heart')) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'slwl-heart slwl-heart--pdp';
      b.setAttribute('data-slwl-p', pi.getAttribute('data-product-id'));
      b.setAttribute('data-slwl-pdp', '');
      b.setAttribute('aria-label', 'Save to favorites');
      b.setAttribute('title', 'Add to favorites');
      b.innerHTML = HEART + '<span class="slwl-heart__t">Favorite</span>';
      /* SWORDSLIFE-OZEL (2026-10-09): kalp "Add to cart" butonunun hemen yaninda (ayni satir) */
      var sub = box.querySelector('.product-form__submit');
      if (sub) sub.insertAdjacentElement('afterend', b); else box.appendChild(b);
    });
    paintHearts();
  }
  function paintHearts() {
    document.querySelectorAll('.slwl-heart[data-slwl-p]').forEach(function (b) {
      var on = has(b.getAttribute('data-slwl-p'));
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (b.hasAttribute('data-slwl-pdp')) b.setAttribute('title', on ? 'Remove from favorites' : 'Add to favorites');
      b.setAttribute('aria-label', on ? 'Remove from favorites' : 'Save to favorites');
      var t = b.querySelector('.slwl-heart__t');
      if (t) t.textContent = on ? 'Saved' : 'Favorite';
    });
  }

  /* ---------------- Ust menu ovali ---------------- */
  var pill, badge;
  function mountPill() {
    if (pill && document.contains(pill)) return;
    var box = document.querySelector('.header__icons--right');
    if (!box) return;
    pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'hp-pill hp-pill--wish sl-wl-pill';
    pill.setAttribute('aria-label', 'Favorites');
    pill.setAttribute('data-slwl-open', '');
    pill.innerHTML = '<span class="hp-ico">' + HEART.replace('<svg', '<svg class="hp-heart"') + '<span class="hp-badge" hidden></span></span>';
    badge = pill.querySelector('.hp-badge');
    var before = box.querySelector('.seller-pill') || box.querySelector('.guest-menu, account-menu, .account-pill, header-account, shopify-account');
    if (before) before.parentNode.insertBefore(pill, before); else box.insertBefore(pill, box.firstChild);
    paintBadge();
  }
  function paintBadge() {
    if (!badge) return;
    var n = S.items.length;
    badge.textContent = n > 99 ? '99+' : String(n);
    badge.hidden = n < 1;
  }

  /* ---------------- Cekmece ---------------- */
  var drawer, dBody, dCount, dFoot;
  function buildDrawer() {
    if (drawer) return;
    drawer = document.createElement('div');
    drawer.className = 'slwl-drawer';
    drawer.hidden = true;
    drawer.innerHTML =
      '<div class="slwl-drawer__bg" data-slwl-close></div>' +
      '<aside class="slwl-drawer__panel" role="dialog" aria-modal="true" aria-labelledby="SlwlTitle">' +
        '<header class="slwl-drawer__head">' +
          '<h2 id="SlwlTitle"><span class="slwl-drawer__ico">' + HEART + '</span>Favorites <span class="slwl-drawer__count" data-slwl-count></span></h2>' +
          '<button type="button" class="slwl-x" data-slwl-close aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
        '</header>' +
        '<div class="slwl-drawer__body" data-slwl-body></div>' +
        '<footer class="slwl-drawer__foot" data-slwl-foot>' +
          '<div class="slwl-share" aria-label="Share your favorites">' +
            '<span>Share</span>' +
            '<button type="button" class="slwl-share__b slwl-share__b--wa" data-slwl-share="wa" aria-label="Share on WhatsApp"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm5.2 14.2c-.2.6-1.3 1.2-1.8 1.2-.5.1-1 .2-3.3-.7-2.8-1.1-4.6-4-4.7-4.2-.1-.2-1.1-1.5-1.1-2.9 0-1.4.7-2 1-2.3.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 2c.1.2.1.4 0 .5l-.4.6-.4.4c-.1.1-.3.3-.1.6.1.3.6 1.1 1.4 1.8 1 .9 1.8 1.1 2.1 1.3.3.1.4.1.6-.1l.8-1c.2-.3.4-.2.6-.1l1.9.9c.3.1.5.2.5.3.1.2.1.7-.1 1.3z"/></svg></button>' +
            '<button type="button" class="slwl-share__b slwl-share__b--tg" data-slwl-share="tg" aria-label="Share on Telegram"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21.9 4.3 18.8 19c-.2 1-.8 1.3-1.7.8l-4.7-3.5-2.3 2.2c-.3.3-.5.5-1 .5l.3-4.8 8.8-8c.4-.3-.1-.5-.6-.2L6.7 12.8 2 11.3c-1-.3-1-1 .2-1.5l18.3-7c.9-.3 1.6.2 1.4 1.5z"/></svg></button>' +
            '<button type="button" class="slwl-share__b" data-slwl-share="copy" aria-label="Copy link"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1"/><path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"/></svg></button>' +
            '<button type="button" class="slwl-share__b" data-slwl-share="more" aria-label="More sharing options"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v12"/><path d="M7.5 7.5 12 3l4.5 4.5"/><path d="M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6"/></svg></button>' +
          '</div>' +
          '<div class="slwl-drawer__btns">' +
            '<button type="button" class="slwl-btn slwl-btn--dark" data-slwl-addall>Add all to cart</button>' +
            '<a class="slwl-btn slwl-btn--line" href="/pages/wishlist">See all</a>' +
          '</div>' +
        '</footer>' +
      '</aside>';
    document.body.appendChild(drawer);
    dBody = drawer.querySelector('[data-slwl-body]');
    dCount = drawer.querySelector('[data-slwl-count]');
    dFoot = drawer.querySelector('[data-slwl-foot]');
  }
  function openDrawer() {
    buildDrawer();
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    /* SWORDSLIFE-OZEL (2026-10-09): kaydirma cubugu kaybolunca sayfa yana kaymasin (kaybolan cubuk kadar bosluk birak) */
    var sw = window.innerWidth - document.documentElement.clientWidth;
    if (sw > 0 && !html.classList.contains('slwl-lock')) html.style.paddingRight = sw + 'px';
    html.classList.add('slwl-lock');
    renderDrawer();
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    html.classList.remove('slwl-lock');
    html.style.paddingRight = '';
    setTimeout(function () { drawer.hidden = true; }, 280);
  }
  function itemRow(pr, it) {
    var v = pickVariant(pr, it.v);
    var img = (v && v.i) || pr.i || '';
    var avail = v ? v.a : pr.a;
    return '<div class="slwl-item" data-p="' + esc(pr.id) + '">' +
      '<a class="slwl-item__img" href="' + esc(pr.u) + (v && !pr.sv ? '?variant=' + v.id : '') + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div class="slwl-item__info">' +
        '<a class="slwl-item__t" href="' + esc(pr.u) + '">' + esc(pr.t) + '</a>' +
        (v && !pr.sv ? '<span class="slwl-item__v">' + esc(v.t) + '</span>' : '') +
        '<span class="slwl-item__p">' + (v ? esc(v.p) : '') + (v && v.c ? ' <s>' + esc(v.c) + '</s>' : '') + '</span>' +
        '<div class="slwl-item__act">' +
          (avail && v ? '<button type="button" class="slwl-mini slwl-mini--dark" data-slwl-cart="' + esc(v.id) + '">Add to cart</button>' : '<span class="slwl-item__out">Sold out</span>') +
          '<button type="button" class="slwl-mini" data-slwl-remove="' + esc(pr.id) + '">Remove</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }
  function renderDrawer() {
    if (!drawer || drawer.hidden) return;
    var items = S.items.slice();
    dCount.textContent = items.length ? '(' + items.length + ')' : '';
    dFoot.hidden = !items.length;
    if (!items.length) {
      dBody.innerHTML = '<div class="slwl-empty"><div class="slwl-empty__ico">' + HEART + '</div><p class="slwl-empty__h">No favorites yet</p><p>Tap the heart on any product to save it here.</p><a class="slwl-btn slwl-btn--dark" href="/collections/all">Explore products</a></div>';
      return;
    }
    if (!dBody.querySelector('.slwl-item')) dBody.innerHTML = items.slice(0, 6).map(function () { return '<div class="slwl-skel"></div>'; }).join('');
    loadProducts(items.map(function (i) { return i.p; })).then(function () {
      var rows = items.map(function (it) {
        var pr = cache[it.p];
        if (!pr || pr.gone) return '';
        return itemRow(pr, it);
      }).join('');
      dBody.innerHTML = rows || '<div class="slwl-empty"><p>These products are no longer available.</p></div>';
    });
  }

  /* ---------------- Paylasim ---------------- */
  function shareUrl(pids, name) {
    var u = location.origin + '/pages/wishlist?share=' + pids.slice(0, 60).join('.');
    if (name) u += '&n=' + encodeURIComponent(name);
    return u;
  }
  function share(kind, pids, name) {
    pids = pids || S.items.map(function (i) { return i.p; });
    if (!pids.length) return;
    var url = shareUrl(pids, name);
    var text = name ? 'My "' + name + '" favorites at Swordslife' : 'My favorites at Swordslife';
    if (kind === 'wa') window.open('https://wa.me/?text=' + encodeURIComponent(text + ' ' + url), '_blank', 'noopener');
    else if (kind === 'tg') window.open('https://t.me/share/url?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(text), '_blank', 'noopener');
    else if (kind === 'more' && navigator.share) navigator.share({ title: text, url: url }).catch(function () {});
    else {
      var done = function () { toast('Link copied'); };
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link:', url); });
      else window.prompt('Copy this link:', url);
    }
  }

  /* ---------------- Tiklamalar ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var h = t.closest('.slwl-heart[data-slwl-p]');
    if (h) {
      e.preventDefault(); e.stopPropagation();
      var v = h.getAttribute('data-slwl-v') || '';
      if (h.hasAttribute('data-slwl-pdp')) {
        var form = h.closest('product-info') && h.closest('product-info').querySelector('form[action*="/cart/add"] input[name="id"]');
        if (form) v = form.value;
      }
      toggle(h.getAttribute('data-slwl-p'), v);
      h.classList.remove('is-pop'); void h.offsetWidth; h.classList.add('is-pop');
      return;
    }
    if (t.closest('[data-slwl-open]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-slwl-close]')) { closeDrawer(); return; }
    var r = t.closest('[data-slwl-remove]');
    if (r) { remove(r.getAttribute('data-slwl-remove')); return; }
    var c = t.closest('[data-slwl-cart]');
    if (c) {
      c.disabled = true; c.textContent = 'Adding…';
      addToCart([{ id: Number(c.getAttribute('data-slwl-cart')), quantity: 1 }]).then(function (ok) {
        c.disabled = false; c.textContent = ok ? 'Added ✓' : 'Add to cart';
        if (ok) toast('Added to cart'); else toast('Sorry, this item is not available');
      });
      return;
    }
    if (t.closest('[data-slwl-addall]')) {
      var btn = t.closest('[data-slwl-addall]');
      var list = S.items.map(function (it) { var pr = cache[it.p]; var v2 = pr && !pr.gone && pickVariant(pr, it.v); return v2 && v2.a ? { id: Number(v2.id), quantity: 1 } : null; }).filter(Boolean);
      if (!list.length) { toast('Nothing available to add'); return; }
      btn.disabled = true; btn.textContent = 'Adding…';
      addToCart(list).then(function (ok) {
        btn.disabled = false; btn.textContent = 'Add all to cart';
        if (ok) { closeDrawer(); if (!openCartDrawer()) location.href = '/cart'; } else toast('Some items could not be added');
      });
      return;
    }
    var s = t.closest('[data-slwl-share]');
    if (s) { share(s.getAttribute('data-slwl-share')); }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------------- Baslat ---------------- */
  listeners.push(function () { paintHearts(); paintBadge(); renderDrawer(); });
  function scan() { mountPill(); mountCards(); mountProduct(); }
  var mo, moT, bootP;
  function start() {
    bootP = boot();
    bootP.then(function () {
      scan();
      syncFromServer();
      mo = new MutationObserver(function () { clearTimeout(moT); moT = setTimeout(scan, 200); });
      mo.observe(document.body, { childList: true, subtree: true });
    });
  }
  window.addEventListener('storage', function (e) { if (e.key === KEY) { S = read() || S; emit(); } });

  /* Disariya acik (favori sayfasi ve Hesabim sayfasi kullanir) */
  window.slWishlist = {
    items: function () { return S ? S.items.slice() : []; },
    lists: function () { return S ? S.lists.slice() : []; },
    has: function (p) { return !!S && has(p); },
    add: function (p, v) { add(p, v, true); },
    remove: function (p) { remove(p, true); },
    toggle: toggle,
    load: loadProducts,
    pick: pickVariant,
    addToCart: addToCart,
    openCart: openCartDrawer,
    share: share,
    shareUrl: shareUrl,
    open: openDrawer,
    onChange: function (f) { listeners.push(f); },
    ready: function (f) { var w = function () { if (bootP) bootP.then(function () { f(); }); else setTimeout(w, 30); }; w(); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
